import {
  TabList as AriaTabList,
  type TabListProps as AriaTabListProps,
} from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

export function TabList2<T extends object>({ children, className, ...props }: AriaTabListProps<T>) {
  return (
    <AriaTabList
      className={cn("tw:flex tw:gap-4 tw:border-b tw:border-b-stroke-quaternary", className)}
      {...props}
    >
      {children}
    </AriaTabList>
  );
}
